var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('click',{staticClass:"view-local-counter",attrs:{"callback":_vm.increment}},[(_vm.shouldRenderLabel)?_c('span',{staticClass:"view-local-counter-label"},[_vm._v(_vm._s(_vm.label)+": ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"view-local-counter-value"},[_vm._v(_vm._s(_vm.valueToRender))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34fc0813","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/counters/LocalCounter.vue
// module id = 293
// module chunks = 0